import { MapPin } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconGeoLocation(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <MapPin />
    </IconWrapper>
  );
}
